import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../i18n';

// Hook personalizado para usar traduções
export const useTranslation = () => {
  const { currentLanguage } = useLanguage();
  
  // Função para obter tradução
  const translate = (key) => {
    return t(key, currentLanguage);
  };
  
  // Função para obter tradução com parâmetros
  const translateWithParams = (key, params = {}) => {
    let translation = t(key, currentLanguage);
    
    // Substitui parâmetros na tradução
    Object.keys(params).forEach(param => {
      translation = translation.replace(`{{${param}}}`, params[param]);
    });
    
    return translation;
  };
  
  // Função para renderizar HTML nas traduções
  const translateHTML = (key) => {
    const translation = translate(key);
    return { __html: translation };
  };
  
  return {
    t: translate,
    translate,
    translateWithParams,
    translateHTML,
    currentLanguage
  };
};
